import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HpcConfig } from '../models/node-config';
import { EnvironmentService } from './environment.service';

// To work on HpcConfig table

@Injectable({
  providedIn: 'root'
})
export class NodeConfigService {

  constructor(private http: HttpClient, private env: EnvironmentService) { }

  // for accessing node configuration
  getHpcConfigDetails(depName: string = '') {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'NodeConfiguration/GetNodeConfigurations'
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
      .set('Deployment', depName)
    return this.http.get(baseUrl, { headers: headers });
  }

  // for adding new node configuration 
  addNewNodeConfig(hpcConfig: HpcConfig) {
    try {
      let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'NodeConfiguration/AddNewNodeConfiguration'
      let headers = new HttpHeaders();
      const hpcConfigInfo = JSON.stringify(hpcConfig);
      headers = headers.set('Content-Type', 'application/json; charset=utf-8')
        .set('Cache-Control', 'no-cache')
      return this.http.post<any>(baseUrl, hpcConfigInfo, {
        headers: headers,
      });
    }
    catch (Error) { }
  }

  // for adding new node configuration 
  addNewNodeConfigs(hpcConfig: Array<HpcConfig>) {
    try {
      let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'NodeConfiguration/ImportNodeConfiguration'
      let headers = new HttpHeaders();
      const hpcConfigInfo = JSON.stringify(hpcConfig);
      headers = headers.set('Content-Type', 'application/json; charset=utf-8')
        .set('Cache-Control', 'no-cache')
      return this.http.post<any>(baseUrl, hpcConfigInfo, {
        headers: headers,
      });
    }
    catch (Error) { }
  }

  // To delete node configuration
  deleteNodeConfig(hpcConfifId) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'NodeConfiguration/DeleteNodeConfiguration/hpcConfigId/' + hpcConfifId
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.post(baseUrl, hpcConfifId, { headers: headers });
  }

  // To Edit node configuration
  updateNodeConfig(hpcConfig: HpcConfig) {
    let baseUrl = this.env.envVariables.httpProtocol + this.env.envVariables.webHost + 'NodeConfiguration/UpdateNodeConfiguration'
    let headers = new HttpHeaders();
    const hpcConfigInfo = JSON.stringify(hpcConfig);
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('Cache-Control', 'no-cache')
    return this.http.post<any>(baseUrl, hpcConfigInfo, {
      headers: headers,
    });
  }
}
